import { render, staticRenderFns } from "./RoleManagement.vue?vue&type=template&id=9580a9f8&scoped=true&"
import script from "./RoleManagement.vue?vue&type=script&lang=js&"
export * from "./RoleManagement.vue?vue&type=script&lang=js&"
import style0 from "./RoleManagement.vue?vue&type=style&index=0&id=9580a9f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9580a9f8",
  null
  
)

export default component.exports